import { useData } from '@app/data/repositories';
import { CasesScreen } from './CasesScreen';
import { useCases } from './useCases';

/**
 * Вход экрана «Дела»: знает про данные и навигацию, сам экран — нет.
 * Та же граница, что у `CasesRoute` и `CasesScreen` на Android.
 */
export function CasesRoute({
  onOpenCase,
  onScan,
  onOpenSettings,
  creating,
  onCreatingChange,
}: {
  onOpenCase: (id: string) => void;
  onScan: (id: string) => void;
  onOpenSettings: () => void;
  creating: boolean;
  onCreatingChange: (creating: boolean) => void;
}) {
  const { db } = useData();
  const { state, actions } = useCases(db);

  return (
    <CasesScreen
      state={state}
      actions={actions}
      onOpenCase={onOpenCase}
      onScan={onScan}
      onOpenSettings={onOpenSettings}
      creating={creating}
      onCreatingChange={onCreatingChange}
    />
  );
}
